export const errorBlock = (text: string) => {
  return {
    type: 'paragraph',
    content: [
      {
        type: 'text',
        text: text,
      },
    ],
  }
}
